import { ImagePage } from "types";

export default {
  type: "imagePage",
  url: "assets/images/showPages/landlord-showpage.jpg",
  action: {
    type: "startJourney",
    journeyId: "landlord",
  },
} as ImagePage;
